/**
 * Синхронная загрузка и встраивание скрипта в HEAD сайта
 * Нужен для общей экономии и дозагрузки скриптов только при необходимости
 */
export function loadScript (url) {
  const e = document.createElement('script')
  e.src = url
  e.async = false
  e.type = 'text/javascript'
  document.getElementsByTagName('head')[0].appendChild(e)
}
window.LoadScript = loadScript // todo: временная совместимость со старыми скриптами
